import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    card: {
        padding: theme.spacing(1),
        textAlign: 'justify'
    },
    total: {
        fontWeight: 'bold'
    },
    finalCard: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    textNota: {
        fontWeight: 'bold',
        color: theme.palette.text.primary,
    },
    feitoEm: {
        lineHeight: 1,
        display: 'flex',
        alignItems: 'end'
    },
    endAlign: {
        display: 'flex',
        alignItems: 'end',
        width: '100%'
    },
    totalLabel: {
        color: theme.palette.text.secondary,
        fontSize: theme.typography.body2.fontSize,
        fontWeight: 'normal',
        marginRight: theme.spacing(1)
    }
}))